import React, { useState, useEffect, useRef } from 'react';
import "./navbar.css";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { GrLanguage } from 'react-icons/gr';
import { useLanguage } from '../../context/LanguageContext';


const LanguageDropdown = ({ direction, ...args }) => {
    const { t, changeLanguage } = useLanguage();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);
    return (
        <Dropdown className='language-dropdown' isOpen={dropdownOpen} toggle={toggle} direction={direction}>
            <DropdownToggle caret className='flex items-center language-dropdown-button'><GrLanguage />&nbsp;</DropdownToggle>
            <DropdownMenu className='language-dropdown-menu' {...args}>
                <DropdownItem className="language-dropdown-item" onClick={() => changeLanguage("tr")}>Türkçe</DropdownItem>
                <DropdownItem className="language-dropdown-item" onClick={() => changeLanguage("en")}>English</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    )
}

export default LanguageDropdown